//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";
import {
  addBeneficiary,
  modalSteps,
  stepPosition,
} from "../../Store/simulate/actions";
import { relationships } from "../../Utils/constants";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import { camposOpcionalesBeneficiario } from "../../Utils/utils";


import { BeneficiaryForm } from "./beneficiaryForm";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import NavCase from "../../Components/FormElements/NavCase";
import BreadCrumbs from "../BreadCrumbs";
import useRouteBack from "../../customHook/useRouteBack";
import FormTitle from "../../Components/FormElements/FormTitle";
import Footer from "../../Components/Footer";
import Button from "../../Components/FormElements/Button";
import ModalFiltering from "../../Components/FormElements/ModalFiltering";

import { RootState } from "../../interfaces/additionalInfo";

import IconBack from "../../Resources/svg/Icons/IconBack";
import IconPlus from "../../Resources/svg/Icons/IconPlus";
import { API } from "aws-amplify";


const beneficiaryDefaultState = {
  tipoDoc: "",
  documento: "",
  nombres: "",
  apePaterno: "",
  apeMaterno: "",
  fecNacimiento: "",
  sexo: "",
  numCelular: "",
  correoElectronico: "",
  idRelacion: null,
  porcentaje: "",
};

const beneficiaryDefauldRg = {
  nameUbigeo: {
    province: "",
    department: "",
    district: "",
  },
  fecNacimiento: "",
  tipoDoc: "",
  documento: "",
  idRelacion: null,
  porcentaje: "",
  nombres: "",
  apePaterno: "",
  address: "",
  apeMaterno: "",
};

export const Beneficiaries = () => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(undefined);
  const data = useSelector((state: any) => state.simulate.policy.client);
  const beneficiariesData = useSelector(
    (state: RootState) => state.simulate.policy.beneficiary
  );
  const client = data.datosCliente;
  const code = data && data.producto ? data.producto.codigo : null;
  const history = useHistory();
  let beneficiaryDefault = code === "RG"  ? beneficiaryDefauldRg : beneficiaryDefaultState

  // exists beneficiaries in redux
  const initData = () => {
    if (beneficiariesData.length > 0) {
      return beneficiariesData;
    } else {
      return [beneficiaryDefault];
    }
  };
  const initErrors = () => {
    if (beneficiariesData.length > 0) {
      return beneficiariesData.map(() => false);
    } else {
      return [true];
    }
  };
  const [beneficiaries, setBeneficiaries] = useState(initData());
  const [totalPercentageBeneficiaries, setTotalPercentageBeneficiaries] =
    useState(beneficiariesData.length === 0 ? 0 : 100);
  const [errorsStt, setErrorsStt] = useState(initErrors());
  const [existsErrors, setExistsErrors] = useState(
    beneficiariesData.length === 0
  );
  const [errorMessage, setErrorMessage] = useState("");

  const [loadingClick, setLoadingClick] = useState(false);

  useEffect(() => {
    dispatch(stepPosition(4));
    
    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:datos-beneficiarios",
      },
      event: "trackVirtual",
    });
  }, []);

  // useEffect(() => console.log(existsErrors, 'existsErrors'), [existsErrors])

  const { handleSubmit } = useForm({ mode: "onChange" });

  const onSubmit = async () => {
    setLoadingClick(true);
    const beneficiariesData = beneficiaries.map((elem: any) => {
      const item = elem;

      item.nombres = getTitleCase(elem.nombres);
      item.apePaterno = getTitleCase(elem.apePaterno);
      item.apeMaterno = getTitleCase(elem.apeMaterno);
      return item;
    });
    setTimeout(() => {
      dispatch(addBeneficiary(beneficiariesData));
      history.push("/cotizaciones/info-complementaria-1");
      dispatch(stepPosition(5));
      setLoadingClick(false);
    }, 500);
  };

  const addItemBeneficiary = (e: any) => {
    e.preventDefault();

    if (validBeneficiariesLimit() >= 100) {
      return false;
    }

    if (beneficiaries.length > 5) {
      setErrorMessage("Solo puede agregar como máximo 6 beneficiarios.");
      return false;
    } else {
      setErrorMessage("");
    }

    if (!existsErrors) {
      setBeneficiaries(beneficiaries.concat(beneficiaryDefault));
    }
    setErrorsStt(errorsStt.concat(true));

    setExistsErrors(true);

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Datos Beneficiarios",
        name: "Click",
        label: "Agregar beneficiario",
      },
      event: "trackAction",
    });
  };

  const updateBeneficiary = (value: any = "", index: any = "", errorFields: any = "") => {
    beneficiaries[index] = value;

    const sumatoriArray = beneficiaries.map((data: any) => data.porcentaje);

    let newBeneficiaries = beneficiaries.map((id: any) => {
      return {
        ...id,
        relacion: relationships[id.idRelacion as keyof typeof relationships],
      };
    });

    setBeneficiaries(newBeneficiaries);
    errorsStt[index] = errorFields;
    setErrorsStt(errorsStt);
    // setExistsErrors(errorsStt.filter(value => value === true).length > 0);
    setExistsErrors(errorFields);
    validBeneficiariesLimit();
  };

  const validBeneficiariesLimit = () => {
    let sum = 0;
    beneficiaries.forEach((elem: any) => {
      sum += parseFloat(elem.porcentaje) || 0;
    });

    setTotalPercentageBeneficiaries(sum);

    return sum;
  };

  const handleCalcOnBlur = () => {
    let sum = 0;
    beneficiaries.forEach((elem: any) => {
      sum += parseFloat(elem.porcentaje) || 0;
    });

    if (beneficiaries.length >= 2) {
      if (sum < 100 || sum > 100) {
        dispatch(modalSteps(true));
        window.digitalData.push({
          log: {
            message: "Revisa el % de beneficiario",
          },
          event: "trackLog",
        });
      }
    }
  };

  const removeBeneficiary = (index: any) => {
    beneficiaries.splice(index, 1);
    setBeneficiaries(beneficiaries);

    let clonErrors = [...errorsStt];
    clonErrors.splice(index, 1);
    setErrorsStt(clonErrors);

    setExistsErrors(errorsStt.filter((value: any) => value === true).length > 0);
    validBeneficiariesLimit();

    dispatch(modalSteps(true));

    window.digitalData.push({
      log: {
        message: "Revisa el % de beneficiario",
      },
      event: "trackLog",
    });

    updateBeneficiary();

    window.digitalData.push({
      action: {
        group: "Inversión Global",
        category: "Datos Beneficiarios",
        name: "Click",
        label: "Eliminar",
      },
      event: "trackAction",
    });
  };

  const setChecked = (val: any) => {
    const beneficiaries = val ? [] : [beneficiaryDefault];
    setIsChecked(val);
    setBeneficiaries(beneficiaries);
    dispatch(addBeneficiary(beneficiaries));
  };

  useBeforeFirstRender(client);

  // const validateBeneficiaries = beneficiaries.every((item: any) =>
  //   Object.entries(item).every(([key, value]) =>
  //   camposOpcionalesBeneficiario.includes(key) || value
  //   )
  // );

  const validateBeneficiaries = beneficiaries.every((item: any) =>
  Object.entries(item).every(([key, value]) =>
    camposOpcionalesBeneficiario.includes(key) || key === 'apeMaterno' || value
  )
);

  const validateBeneficiarieUbigeo = () =>
    beneficiaries.every((item: any) => Object.values(item.nameUbigeo).every((value) => value));

  return (
    <>
      <div className="wrap">
        <NavResponsive position={4} title="Datos de beneficiarios"/>
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack
                className="nav-case__back"
                onClick={() => useRouteBack(history)}
              />
              <div className="nav-case__title">Datos de beneficiarios</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            <FormTitle
              title="Ingresa los beneficiarios del contratante"
              parrafo="Personas que serán indemnizadas en caso de fallecimiento."
            />

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="healthCard">
                <div className="healthCard__title">Beneficiarios legales</div>
                <p className="healthCard__parrafo">
                  En caso el ASEGURADO no haya designado BENEFICIARIOS, o por cualquier causa la designación se vuelva ineficaz o quede sin efecto, los BENEFICIARIOS serán los herederos legales declarados de acuerdo a ley.
                </p>
                <div className="clientForm__form__item">
                  <p>
                    <label>
                      <input
                        className="with-gap"
                        name="isCheckLegal"
                        //id="yes_isCheckLegal"
                        type="radio"
                        value="true"
                        onChange={() => setChecked(true)}
                      />
                      <span>Sí</span>
                    </label>
                  </p>
                  <p>
                    <label>
                      <input
                        className="with-gap"
                        name="isCheckLegal"
                        //id="no_isCheckLegal"
                        type="radio"
                        value="false"
                        onChange={() => setChecked(false)}
                      />
                      <span>No</span>
                    </label>
                  </p>
                </div>

                {isChecked == false && (
                  <div className={`clientForm__container`}>
                    <div className="clientForm__title-card">
                      Datos de los beneficiarios
                    </div>
                    <div className="clientForm__subtitle">
                      Considera que los porcentajes asignados deben sumar 100%.
                    </div>

                    {beneficiaries.map((beneficiary: any, index: number) => (
                      <BeneficiaryForm
                        key={index}
                        beneficiary={beneficiary}
                        index={index}
                        updateBeneficiary={updateBeneficiary}
                        removeBeneficiary={removeBeneficiary}
                        count={beneficiaries.length}
                        existsErrors={existsErrors}
                        handleCalcOnBlur={handleCalcOnBlur}
                        productCode={data}
                      />
                    ))}

                    <div
                      className="clientForm__add"
                      onClick={(e) => addItemBeneficiary(e)}
                    >
                      <IconPlus />
                      <p className="clientForm__add-text">
                        Agregar beneficiario
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="form-register__border"></div>
              <div className="form-register__buttom form-step">
                { code === 'RG' ? (<Button
                  type="submit"
                  className={loadingClick ? "is-loading" : ""}
                  disabled={
                    isChecked
                      ? false
                      : existsErrors ||
                        totalPercentageBeneficiaries !== 100 ||
                        !validateBeneficiaries 
                      ? true
                       : !validateBeneficiarieUbigeo() ? true : false
                  }
                >
                  Continuar
                </Button>) : (<Button
                  type="submit"
                  className={loadingClick ? "is-loading" : ""}
                  disabled={
                    isChecked
                      ? false
                      : existsErrors ||
                        totalPercentageBeneficiaries !== 100 ||
                        !validateBeneficiaries 
                      ? true
                       : false
                  }
                >
                  Continuar
                </Button>)}
              </div>
            </form>
          </div>
        </div>
      </div>

      <ModalFiltering className="modal-result is-midle" variant={true}>
        <h2 className="modal-result__title">Revisa el % de beneficio</h2>
        <div className="modal-result__desc">
          Ten en cuenta que la suma del porcentaje de los beneficiarios debe ser
          igual a <span>100%</span>.
        </div>
        <div className="actions">
          <Button
            className="actions__continue"
            onClick={() => dispatch(modalSteps(false))}
          >
            Entendido
          </Button>
        </div>
      </ModalFiltering>
      <Footer />
    </>
  );
};
